export const SET_LOADING_DATA = '@notifications/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@notifications/SET_LOADING_SEND';

export const GET_ALL_REQUEST = '@notifications/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@notifications/GET_ALL_SUCCESS';

export const SEARCH = '@notifications/SEARCH';

export const SET_PAGE = '@rewards/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@notifications/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@notifications/SET_ORDER';
export const SET_ORDERBY = '@notifications/SET_ORDEBY';
